module.exports = __webpack_public_path__ + "img/ron_d.668a7ed6.png";